import { render, staticRenderFns } from "./BloqueIconos.vue?vue&type=template&id=7a4c4128&scoped=true"
import script from "./BloqueIconos.vue?vue&type=script&lang=js"
export * from "./BloqueIconos.vue?vue&type=script&lang=js"
import style0 from "./BloqueIconos.vue?vue&type=style&index=0&id=7a4c4128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4c4128",
  null
  
)

export default component.exports